import useLoginState from "common/hooks/useLoginState";

const useCurrentUserBusinessId = () => {
  const { getCurrentUserBusinessId } = useLoginState();
  return getCurrentUserBusinessId() || null;
};

export default useCurrentUserBusinessId;
